// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#tableEncuestas[data-v-7caee054]{border-collapse:collapse;width:100%;text-align:center;overflow-x:scroll;white-space:nowrap}#tableEncuestas td[data-v-7caee054],#tableEncuestas th[data-v-7caee054]{padding:10px;text-align:left;border:1px solid #ddd}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
